import React from 'react';
import { makeStyles } from '@material-ui/core';
import PublicLayout from '../layouts/PublicLayout';
import useSEO from '../seo/use-seo';
import StandardPageHelmet from '../seo/components/StandardPageHelmet';
import { GenesisHeroSection } from './GenesisCollection/GenesisHeroSection';
import { GenesisFoundingRoster, GenesisTopPerformers } from './GenesisCollection/GenesisRosters';
import { GenesisInterestedCTA, GenesisCommunityCTA } from './GenesisCollection/GenesisCTAs';

const useStyles = makeStyles((theme) => ({
  pageContainer: {
    backgroundColor: '#111111',
    minHeight: '100vh',
    paddingBottom: '70px',
    color: '#fff',
  }
}));

export default function GenesisCollectionPage() {
  const classes = useStyles();
  const seo = useSEO("login"); 

  return (
    <PublicLayout>
      <StandardPageHelmet seo={seo} />
      <div className={classes.pageContainer}>
        <GenesisHeroSection />
        <GenesisFoundingRoster />
        <GenesisInterestedCTA />
        <GenesisTopPerformers />
        <GenesisCommunityCTA />
      </div>
    </PublicLayout>
  );
}

